import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { i18n } from "services/i18nService";

export function ConfirmationDialog(props) {
  const { open, onClose, record } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      sx={{ inset: "0 0 30%" }}
    >
      <DialogTitle>{i18n("upsShipment.UPSShipmentConfirmation")}</DialogTitle>
      <DialogContent>
        <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
          <div style={{ fontWeight: "bold", textAlign: "right" }}>
            {i18n("upsShipment.TotalCharges")}:
          </div>
          <div style={{ flexGrow: 1 }}>{record.totalCharges}</div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          {i18n("button.Close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
